<script>
import { UserService } from "@/service";
import Upload from "@/components/upload/index.vue";
export default {
	props: {
		// 标签数组
		dataSource: {
			default() {
				return [];
			},
		},
		// 用户详情
		infoData: {
			default() {
				return {};
			},
		},
		// 类型
		userType: {
			default: "",
		},
	},
	watch: {
		infoData: {
			immediate: true,
			// deep: true,
			handler(newValue, oldValue) {
				if (newValue && Object.keys(newValue).length > 0) {
					this.form = newValue;
					this.basicUrls = [...(newValue.designCertificates || [])];
				}
			},
		},
	},
	data() {
		return {
			basicUrls: [],
			form: {
				id: "",
				userType: "设计工程师",
				gender: "",
				age: "",
				designSoftware: [],
				designOtherSoftware: "",
				designAnalysis: [],
				designOtherAnalysis: "",
				designTechnology: [],
				designOtherTechnology: "",
				designProduct: "",
				designCertificates: [],
				designDescription: "",
			},
			rules: {
				gender: [{ required: true, message: "请选择性别", trigger: "change" }],
				age: [{ required: true, message: "请选择年龄", trigger: "change" }],
			},
		};
	},
	mounted() {},
	methods: {
		setState(obj) {
			for (let key in obj) {
				this.form[key] = obj[key];
			}
		},
		formChange(value) {
			this.setState({
				value,
			});
		},
		async handleSubmit() {
			this.$message.info("提交中...");
			const res = await UserService.SaveDescription({ ...this.form, userType: this.userType });
			if (res.code == 0) {
				this.$message.success("提交成功");
				this.$emit("refresh");
			}
		},
		RadioChange(key, value) {
			this.form[key] = ["id", "userType", "gender", "age"].includes(key) ? value : [value];
		},
		SelectChange(key, value) {
			const data = this.form[key] || [];
			let index = data.indexOf(value);
			if (index > -1) {
				data.splice(index, 1);
			} else {
				if (data?.length >= 5) {
					this.$message.warning("最多选择5个");
				} else {
					data.push(value);
				}
			}
			this.setState({ [key]: data });
		},
		onUploadSuccess(ids, key) {
			console.log("onUploadSuccess	", ids, key);
			this.setState({ [key]: ids });
		},
	},
	render() {
		const { dataSource, form, rules } = this;
		return (
			<el-form class="design-form" props={{ model: form, rules: rules }} label-width={"110px"}>
				<el-form-item label="性别：" prop="gender">
					<span onClick={() => this.RadioChange("gender", 1)} class={`label-data ${1 === parseInt(form.gender, 10) ? "active" : ""}`}>
						男
					</span>
					<span onClick={() => this.RadioChange("gender", 2)} class={`label-data ${2 === parseInt(form.gender, 10) ? "active" : ""}`}>
						女
					</span>
				</el-form-item>
				<el-form-item label="年龄：" prop="age">
					{dataSource[9]
						? dataSource[9].map((item, index) => {
								return (
									<span
										class={`label-data ${item.id === parseInt(form.age, 10) ? "active" : ""}`}
										key={index}
										onClick={() => this.RadioChange("age", item.id)}>
										{item.tagName}
									</span>
								);
						  })
						: ""}
				</el-form-item>
				<el-form-item label="擅长设计软件：">
					{(dataSource[6] || []).map((item, index) => {
						return (
							<span
								class={`label-data ${form.designSoftware.includes(item.id) ? "active" : ""}`}
								key={index}
								onClick={() => this.SelectChange("designSoftware", item.id)}>
								{item.tagName}
							</span>
						);
					})}
				</el-form-item>
				<el-form-item label="其他设计软件：">
					<el-input size="mini" placeholder="请输入..." v-model={form.designOtherSoftware} class="inputs-other" />
				</el-form-item>

				<el-form-item label="擅长分析软件：">
					{(dataSource[7] || []).map((item, index) => {
						return (
							<span
								class={`label-data ${form.designAnalysis.includes(item.id) ? "active" : ""}`}
								key={index}
								onClick={() => this.SelectChange("designAnalysis", item.id)}>
								{item.tagName}
							</span>
						);
					})}
				</el-form-item>
				<el-form-item label="其他分析软件：">
					<el-input size="mini" placeholder="请输入..." v-model={form.designOtherAnalysis} class="inputs-other" />
				</el-form-item>

				<el-form-item label="技术能力：">
					{(dataSource[8] || []).map((item, index) => {
						return (
							<span
								class={`label-data ${form.designTechnology.includes(item.id) ? "active" : ""}`}
								key={index}
								onClick={() => this.SelectChange("designTechnology", item.id)}>
								{item.tagName}
							</span>
						);
					})}
				</el-form-item>
				<el-form-item label="其他能力：">
					<el-input size="mini" placeholder="请输入..." v-model={form.designOtherTechnology} class="inputs-other" />
				</el-form-item>
				<el-form-item label="擅长产品：">
					<el-input size="mini" placeholder="请输入..." v-model={form.designProduct} class="inputs-other" />
				</el-form-item>
				<el-form-item label="等级证书：">
					<Upload
						basicIds={form.designCertificatesId}
						basicUrls={this.basicUrls}
						onUploadSuccess={(ids) => {
							this.onUploadSuccess(ids, "designCertificates");
						}}
					/>
				</el-form-item>

				<el-form-item label="技术能力描述：">
					<el-input size="mini" placeholder="请输入..." v-model={form.designDescription} class="inputs-other" />
				</el-form-item>
				<div style="text-align: center">
					<span class="label-data active btn" onClick={() => this.handleSubmit()}>
						确定
					</span>
				</div>
			</el-form>
		);
	},
};
</script>

<style lang="less" scoped>
@import "./skill.less";
</style>
